// index.js
import React, { Component, Fragment } from 'react';
import { Well } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import BillingForm from './Forms';
import iconTip from '../../static/images/icon-tip.svg';
import { modal, paypal, receipts } from '../../store/actions';
import ModalView from '../Feature/ModalView';
import { VATrate } from '../../utils/price_config';
import PaypalButton from '../Feature/PaypalButton';
import { addUserCredits } from '../../utils/user';
import { update_credits } from '../../utils/apputils';

class BillingClass extends Component {
  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(paypal.ready());
  }

  onPayment = receipt => {
    const {
      creditsPackage: { name },
      dispatch
    } = this.props;
    const addCredits = async () => {
      const result = await addUserCredits(name);
      if (result) {
        update_credits(dispatch);
      }
    };
    addCredits();
    dispatch(paypal.complete());
    if (receipt) {
      dispatch(receipts.setCurrentReceipt(receipt.response));
    }
  };

  setReceipt = () => {
    const { receipt } = this.props;
    localStorage.setItem('receipts', JSON.stringify(receipt));
  };

  handleClose = () => {
    const { dispatch } = this.props;
    dispatch(modal.modalHide());
  };

  payPalCompleteModal = () => {
    const title = 'Purchase complete';
    const body = (
      <div className="footer-buttons">
        <button
          type="button"
          className="btn btn-default btn-bevel"
          onClick={this.handleClose}
        >
          Close
        </button>
        <Link to="/receipts/anon" target="_blank">
          <button
            type="button"
            className="btn btn-primary btn-bevel"
            onMouseDown={this.setReceipt}
          >
            View receipt
          </button>
        </Link>
      </div>
    );
    const footer = (
      <div className="tip-text">
        <span>
          Head to Your Orders to view a copy of your receipt at any time.
        </span>
      </div>
    );
    const footerTip = true;

    return { title, body, footer, footerTip };
  };

  payPalIncompleteModal = () => {
    const { buttonClickMsg, creditsPackage, dispatch, status } = this.props;
    const title = 'Get your tasty credits here';
    const body = (
      <Fragment>
        <h3 className="bar-header">Purchase credits</h3> <BillingForm />
        <p className="smallprint vat-smallprint">
          Prices include VAT at {VATrate * 100}%
        </p>
      </Fragment>
    );
    const footer = (
      <div>
        {buttonClickMsg ? (
          <p className="smallprint purchase-credits-warning">
            {buttonClickMsg}
          </p>
        ) : null}
        <div className="footer-buttons">
          <button
            type="button"
            className="btn btn-default btn-bevel"
            onClick={this.handleClose}
          >
            Not now, thanks
          </button>
          <div>
            <PaypalButton
              dispatch={dispatch}
              creditsPackage={creditsPackage}
              onPayment={this.onPayment}
              status={status}
            />
          </div>
        </div>
      </div>
    );
    const footerTip = false;

    return { title, body, footer, footerTip };
  };

  modalExtra = () => {
    return (
      <div className="modal-footer modal-footer--tip">
        <img className="tip-icon" src={iconTip} width="310" alt="" />
        <div className="tip-text">
          <span>
            Each credit buys you one image mockup, which is saved in your
            account forever.
          </span>
        </div>
      </div>
    );
  };

  render() {
    const { user, status, showModal } = this.props;

    if (user === null) {
      return (
        <div className="container">
          <h1>You need to login</h1>
          <Well className="account-well" bsSize="large">
            <p>Hit the 'Log in' button in the bar up there</p>
          </Well>
        </div>
      );
    }

    if (user !== null) {
      const { title, body, footer, footerTip } =
        status === paypal.types.COMPLETE
          ? this.payPalCompleteModal()
          : this.payPalIncompleteModal();
      const extra = this.modalExtra();

      return (
        <ModalView
          id="m_regbuy2"
          title={title}
          body={body}
          footer={footer}
          footerTip={footerTip}
          show={showModal}
          close={this.handleClose}
          extra={extra}
        />
      );
    }
  }
}

const mapStateToProps = state => ({
  user: state.users.user,
  status: state.paypal.status,
  showModal: state.modal.showModal,
  receipt: state.receipts.receipt,
  creditsPackage: state.paypal.creditsPackage,
  buttonClickMsg: state.paypal.buttonClickMsg
});

const Billing = connect(mapStateToProps)(BillingClass);

export default Billing;



// WEBPACK FOOTER //
// ./src/comps/Billing/index.js